import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'ui-modal',
  template: `<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" (click)="toggle()">
  Launch demo modal
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" [ngClass]="{'show':showModel}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggle()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="toggle()">Close</button>
        <button type="button" class="btn btn-primary" (click)="toggle()">Save changes</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showModel"></div>
`,
  styles: [`.show{display:block;padding-right:16px}`]
})
export class ModalComponent implements OnInit {
  showModel: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  toggle() {
    this.showModel = !this.showModel;
  }

}
